import { render, staticRenderFns } from "./BallonTemplate.vue?vue&type=template&id=641a869f&scoped=true&"
import script from "./BallonTemplate.vue?vue&type=script&lang=js&"
export * from "./BallonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BallonTemplate.vue?vue&type=style&index=0&id=641a869f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a869f",
  null
  
)

export default component.exports